import { createContext, useEffect, useReducer } from "react";

import altaProtocoloPcrInitialState from "./initialStates/altaProtocoloPcrInitialState";
import ayudaInitialState from "./initialStates/ayudaInitialState";
import modalInitialState from "./initialStates/modalInitialState";
import segundoModalInitialState from "./initialStates/segundoModalInitialState";
import obraSocialInitialState from "./initialStates/obraSocialInitialState";
import planObraSocialInitialState from "./initialStates/planObraSocialInitialState";
import validaMobileInitialState from "./initialStates/validaMobileInitialState";
import pacienteInitialState from "./initialStates/pacienteInitialState";
import tokenInitialState from "./initialStates/tokenInitialState";
import vcTokenInitialState from "./initialStates/vcTokenInitialState";
import estudioGrupoInitialState from "./initialStates/estudioGrupoInitialState";
import laboGrupoInitialState from "./initialStates/laboGrupoInitialState";
import laboTurnosInitialState from "./initialStates/laboTurnosInitialState";
import tokenGoogleInitialState from "./initialStates/accessTokenInitialState";
import textosInitialState from "./initialStates/textosInitialState";
import mercadoPagoInitialState from "./initialStates/mercadoPagoInitialState";
import ordenEstudioInitialState from "./initialStates/ordenEstudioInitialState";
import ordenLaboratorioInitialState from "./initialStates/ordenLaboratorioInitialState";
import turnosPacienteInitialState from "./initialStates/turnosPacienteInitialState";
import listaFamiliaresInitialState from "./initialStates/listaFamiliaresInitialState";
import selectDropDownInitialState from "./initialStates/selectDropDownState";
import tokenFCMInitialState from "./initialStates/tokenFCMInitialState";
import dispositivoPacienteInitialState from "./initialStates/dispositivoPacienteInitialState";
import estudioTurnosInitialState from "./initialStates/estudioTurnosInitialState";
import consultaMedTurnosInitialState from "./initialStates/consultaMedTurnosInitialState";
import turnosDisponiblesInitialState from "./initialStates/turnosDisponiblesInitialState";
import ordenDigitalInitialState from "./initialStates/ordenDigitalInitialState";
import labOrdenDigitalInitialState from "./initialStates/labOrdenDigitalInitialState";
import motivoCancelacionInitialState from "./initialStates/motivoCancelacionInitialState";
import cancelacionInitialState from "./initialStates/cancelacionInitialState";
import verificaDniInitialState from "./initialStates/verificaDniInitialState";
import registroInitialState from "./initialStates/registroInitialState";

import altaProtocoloPcr from "./reducers/altaProtocoloPcr";
import ayuda from "./reducers/ayuda";
import modal from "./reducers/modal";
import segundoModal from "./reducers/segundoModal";
import obraSocial from "./reducers/obraSocial";
import planObraSocial from "./reducers/planObraSocial";
import validaMobile from "./reducers/validaMobile";
import paciente from "./reducers/paciente";
import token from "./reducers/token";
import vcToken from "./reducers/vcToken";
import estudioGrupo from "./reducers/estudioGrupo";
import laboGrupo from "./reducers/laboGrupo";
import laboTurnos from "./reducers/laboTurnos";
import tokenGoogle from "./reducers/accessToken";
import textos from "./reducers/textos";
import mercadoPago from "./reducers/mercadoPago";
import ordenEstudio from "./reducers/ordenEstudio";
import ordenLaboratorio from "./reducers/ordenLaboratorio";
import turnosPaciente from "./reducers/turnosPaciente";
import listaFamiliares from "./reducers/listaFamiliares";
import selectDropDown from "./reducers/selectDropDown";
import tokenFCM from "./reducers/tokenFCM";
import estudioTurnos from "./reducers/estudioTurnos";
import consultaMedTurnos from "./reducers/consultaMedTurnos";
import turnosDisponibles from "./reducers/turnosDisponibles";
import ordenDigital from "./reducers/ordenDigital";
import labOrdenDigital from "./reducers/labOrdenDigital";
import motivoCancelacion from "./reducers/motivoCancelacion";
import cancelacion from "./reducers/cancelacion";
import verificaDni from "./reducers/verificaDni";
import registro from "./reducers/registro";

import dispositivoPaciente from "./reducers/dispositivoPaciente";
import { RESET_PORTAL_CONTEXT } from "./ActionTypes";
import { useHistory } from "react-router";
import { Network } from "@capacitor/network";

export const PortalContext = createContext();

export const PortalProvider = ({ children }) => {
  const [modalState, modalDispatch] = useReducer(modal, modalInitialState);
  const [segundoModalState, segundoModalDispatch] = useReducer(
    segundoModal,
    segundoModalInitialState
  );
  const [obraSocialState, obraSocialDispatch] = useReducer(
    obraSocial,
    obraSocialInitialState
  );
  const [planObraSocialState, planObraSocialDispatch] = useReducer(
    planObraSocial,
    planObraSocialInitialState
  );
  const [validaMobileState, validaMobileDispatch] = useReducer(
    validaMobile,
    validaMobileInitialState
  );
  const [verificaDniState, verificaDniDispatch] = useReducer(
    verificaDni,
    verificaDniInitialState
  );
  const [registroState, registroDispatch] = useReducer(
    registro,
    registroInitialState
  );
  const [pacienteState, pacienteDispatch] = useReducer(
    paciente,
    pacienteInitialState
  );
  const [cancelacionState, cancelacionDispatch] = useReducer(
    cancelacion,
    cancelacionInitialState
  );
  const [tokenState, tokenDispatch] = useReducer(token, tokenInitialState);
  const [estudioGrupoState, estudioGrupoDispatch] = useReducer(
    estudioGrupo,
    estudioGrupoInitialState
  );
  const [laboGrupoState, laboGrupoDispatch] = useReducer(
    laboGrupo,
    laboGrupoInitialState
  );
  const [laboTurnosState, laboTurnosDispatch] = useReducer(
    laboTurnos,
    laboTurnosInitialState
  );
  const [tokenGoogleState, tokenGoogleDispatch] = useReducer(
    tokenGoogle,
    tokenGoogleInitialState
  );
  const [estudioTurnosState, estudioTurnosDispatch] = useReducer(
    estudioTurnos,
    estudioTurnosInitialState
  );
  const [consultaMedTurnosState, consultaMedTurnosDispatch] = useReducer(
    consultaMedTurnos,
    consultaMedTurnosInitialState
  );
  const [textosState, textosDispatch] = useReducer(textos, textosInitialState);
  const [turnosDisponiblesState, turnosDisponiblesDispatch] = useReducer(
    turnosDisponibles,
    turnosDisponiblesInitialState
  );
  const [ordenEstudioState, ordenEstudioDispatch] = useReducer(
    ordenEstudio,
    ordenEstudioInitialState
  );
  const [ordenLaboratorioState, ordenLaboratorioDispatch] = useReducer(
    ordenLaboratorio,
    ordenLaboratorioInitialState
  );
  const [turnosPacienteState, turnosPacienteDispatch] = useReducer(
    turnosPaciente,
    turnosPacienteInitialState
  );
  const [mercadoPagoState, mercadoPagoDispatch] = useReducer(
    mercadoPago,
    mercadoPagoInitialState
  );
  const [motivoCancelacionState, motivoCancelacionDispatch] = useReducer(
    motivoCancelacion,
    motivoCancelacionInitialState
  );
  const [ayudaState, ayudaDispatch] = useReducer(ayuda, ayudaInitialState);
  const [labOrdenDigitalState, labOrdenDigitalDispatch] = useReducer(
    labOrdenDigital,
    labOrdenDigitalInitialState
  );
  const [ordenDigitalState, ordenDigitalDispatch] = useReducer(
    ordenDigital,
    ordenDigitalInitialState
  );
  const [listaFamiliaresState, listaFamiliaresDispatch] = useReducer(
    listaFamiliares,
    listaFamiliaresInitialState
  );
  const [selectDropDownState, selectDropDownDispatch] = useReducer(
    selectDropDown,
    selectDropDownInitialState
  );
  const [altaProtocoloPcrState, altaProtocoloPcrDispatch] = useReducer(
    altaProtocoloPcr,
    altaProtocoloPcrInitialState
  );
  const [vcTokenState, vcTokenDispatch] = useReducer(
    vcToken,
    vcTokenInitialState
  );
  const [tokenFCMState, tokenFCMDispatch] = useReducer(
    tokenFCM,
    tokenFCMInitialState
  );
  const [dispositivoPacienteState, dispositivoPacienteDispatch] = useReducer(
    dispositivoPaciente,
    dispositivoPacienteInitialState
  );

  //RESET CONTEXT
  const arrayDispatch = [
    modalDispatch,
    obraSocialDispatch,
    planObraSocialDispatch,
    validaMobileDispatch,
    pacienteDispatch,
    tokenDispatch,
    estudioGrupoDispatch,
    laboGrupoDispatch,
    laboTurnosDispatch,
    tokenGoogleDispatch,
    ordenEstudioDispatch,
    ordenLaboratorioDispatch,
    turnosPacienteDispatch,
    mercadoPagoDispatch,
    ayudaDispatch,
    listaFamiliaresDispatch,
    selectDropDownDispatch,
    altaProtocoloPcrDispatch,
    segundoModalDispatch,
    vcTokenDispatch,
    tokenFCMDispatch,
    dispositivoPacienteDispatch,
  ];

  const sessionStorageExclusion = [];
  const localStorageExclusion = [
    "config",
    "_cap_welcomeActive",
    "mercadoPago",
    "subidaOrden",
    "dtoSegundoFactor",
  ];

  const limpiarStorage = (sessionExcepcion, localExcepcion) => {
    //limpiar sessionStorage
    if (Object.keys(sessionStorage).length > 0) {
      Object.keys(sessionStorage).map(
        (key) =>
          !sessionExcepcion.includes(key) && sessionStorage.removeItem(key)
      );
    }
    //limpiar localStorage
    if (Object.keys(localStorage).length > 0) {
      Object.keys(localStorage).map(
        (key) => !localExcepcion.includes(key) && localStorage.removeItem(key)
      );
    }
  };

  const resetPortalContext = (index) => {
    if (Array.isArray(arrayDispatch)) {
      if (index >= arrayDispatch.length) {
        limpiarStorage(sessionStorageExclusion, localStorageExclusion);
        return;
      }
      const dispatch = arrayDispatch[index];
      dispatch({ type: RESET_PORTAL_CONTEXT });
      resetPortalContext(index + 1);
    }
  };

  const history = useHistory();
  useEffect(() => {
    const screen = window?.screen;
    if (screen) {
      let networkTimeout;

      Network.addListener("networkStatusChange", (status) => {
        if (!status.connected) {
          // Esperar 2 minutos antes de redirigir para evitar desconexiones temporales
          networkTimeout = setTimeout(() => {
            // Verificar nuevamente el estado de la red antes de redirigir
            Network.getStatus().then((currentStatus) => {
              if (!currentStatus.connected) {
                history.push("/");
              }
            });
          }, 120000); // 2 minutos = 120000 ms
        } else {
          // Si la red se restaura, cancelar el timeout
          if (networkTimeout) {
            clearTimeout(networkTimeout);
            networkTimeout = null;
          }
        }
      });

      // Cleanup function
      return () => {
        if (networkTimeout) {
          clearTimeout(networkTimeout);
        }
      };
    }
  }, []);

  return (
    <PortalContext.Provider
      value={{
        modalState,
        modalDispatch,
        obraSocialState,
        obraSocialDispatch,
        planObraSocialState,
        planObraSocialDispatch,
        validaMobileState,
        validaMobileDispatch,
        verificaDniState,
        verificaDniDispatch,
        registroState,
        registroDispatch,
        pacienteState,
        pacienteDispatch,
        cancelacionState,
        cancelacionDispatch,
        tokenState,
        tokenDispatch,
        estudioGrupoState,
        estudioGrupoDispatch,
        laboGrupoState,
        laboGrupoDispatch,
        laboTurnosState,
        laboTurnosDispatch,
        tokenGoogleState,
        tokenGoogleDispatch,
        estudioTurnosState,
        estudioTurnosDispatch,
        consultaMedTurnosState,
        consultaMedTurnosDispatch,
        turnosDisponiblesState,
        turnosDisponiblesDispatch,
        textosState,
        textosDispatch,
        ordenEstudioState,
        ordenEstudioDispatch,
        ordenLaboratorioState,
        ordenLaboratorioDispatch,
        turnosPacienteState,
        turnosPacienteDispatch,
        mercadoPagoState,
        mercadoPagoDispatch,
        motivoCancelacionState,
        motivoCancelacionDispatch,
        ayudaState,
        ayudaDispatch,
        listaFamiliaresState,
        listaFamiliaresDispatch,
        selectDropDownState,
        selectDropDownDispatch,
        altaProtocoloPcrState,
        altaProtocoloPcrDispatch,
        segundoModalState,
        segundoModalDispatch,
        vcTokenState,
        vcTokenDispatch,
        tokenFCMState,
        tokenFCMDispatch,
        dispositivoPacienteState,
        dispositivoPacienteDispatch,
        labOrdenDigitalState,
        labOrdenDigitalDispatch,
        ordenDigitalState,
        ordenDigitalDispatch,
        resetPortalContext,
      }}
    >
      {children}
    </PortalContext.Provider>
  );
};
